var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import cs from 'classnames';
import { useComplianceStore } from 'common/services/compliance-service/service-store/service-store';
import { complianceServiceShouldShowPageSelector } from 'common/services/compliance-service/service-store/selectors';
import { Paper } from 'ui-kit/paper';
import { Button } from 'ui-kit/button';
import { Typography } from 'ui-kit/typography';
import { Icon } from 'ui-kit/icon';
import { CookieIcon } from 'common/icons';
import { ROUTES } from 'common/routing';
import styles from './cookies-agreements.module.scss';
export var CookiesAgreement = function () {
    var _a;
    var t = useTranslation().t;
    var pathname = useLocation().pathname;
    var isComplianceDocumentExist = useComplianceStore(complianceServiceShouldShowPageSelector);
    var _b = useState(false), visible = _b[0], setIsVisible = _b[1];
    useEffect(function () {
        var consent = localStorage.getItem('cookieAgreement');
        if (!consent && isComplianceDocumentExist) {
            setIsVisible(true);
        }
    }, [isComplianceDocumentExist]);
    var acceptCookies = function () {
        localStorage.setItem('cookieAgreement', 'true');
        setIsVisible(false);
    };
    if (!visible) {
        return null;
    }
    return (_jsxs(Paper, __assign({ className: cs(styles.agreements, (_a = {}, _a[styles.compliancePage] = pathname.includes('compliance'), _a)) }, { children: [_jsx("div", __assign({ className: styles.icon }, { children: _jsx(Icon, { width: 2, hanging: 2, viewBox: "0 0 32 32", component: CookieIcon }) })), _jsxs(Typography, __assign({ className: styles.text, variant: "body-s" }, { children: [t('compliance.cookies.text'), "\u00A0", _jsx(Link, __assign({ className: styles.link, to: ROUTES.COOKIES, target: "_blank", rel: "noopener noreferrer" }, { children: t('compliance.cookies.cookiesLinkText') }))] })), _jsx(Button, __assign({ className: styles.button, onClickSimple: acceptCookies }, { children: t('compliance.cookies.agreementButtonText') }))] })));
};
